const hsname = window.location.hostname;
let env="";
let bsurl = "";
let myskilUrl="";
let myCarrUrl="";
let carlaturl="";

if (hsname == "localhost") {
  bsurl = "https://localhost:44328";
  env="loc";
   myCarrUrl="http://localhost:3000";
  myskilUrl="https://dev-myskills-oneit.rrd.com/";
} else if (hsname == "myconnect-uatmycareer.rrd.com") {
  bsurl = "https://myconnect-uatmycareer.rrd.com/MyCareerAPI";
  env="dev";
  myskilUrl="https://dev-myskills-oneit.rrd.com/";
  carlaturl="https://myconnect-uatmycareer.rrd.com/carrerlattice";
} else if (hsname == "myconnect-mycareer.rrd.com") {
  bsurl = "https://myconnect-mycareer.rrd.com/MyCareerAPI";
  env="prod";
  myskilUrl="https://myskills-oneit.rrd.com/";
  carlaturl="https://myconnect-mycareer.rrd.com/carrerlattice";
  myCarrUrl="https://myconnect.rrd.com/"
}else {
  bsurl = "https://dev-mycareer.rrd.com/MyCareerAPI";
  env="uat";
  carlaturl="https://myconnect-mycareer.rrd.com/carrerlattice";
  myskilUrl="https://dev-myskills-oneit.rrd.com/";
}
bsurl = "https://myconnect-mycareer.rrd.com/MyCareerAPI";
env="prod";
myskilUrl="https://myskills-oneit.rrd.com/";
carlaturl="https://myconnect-mycareer.rrd.com/carrerlattice";
myCarrUrl="https://myconnect.rrd.com/"

export const baseurl = bsurl;
export const environ = env;
export const mySkillUrl = myskilUrl;
export const MycarUrl = myCarrUrl;
export const Careerlat=carlaturl
//